import { h, render } from 'preact';
import FastClick from 'fastclick';
import 'modernizr';

// @TEMP: Use this both locally and online to ease debugging:
import 'preact/devtools';

// Use fastclick for faster taps
FastClick.attach(document.body);

// @TODO: Hacky pinch zoom disabled for ios:
// stackoverflow.com/questions/37808180/disable-viewport-zooming-ios-10-safari
// "updated on iOS11 release, iOS 11 safari still DO NOT respect
// the user-scalable=no meta tag."
document.addEventListener('touchmove', event => {
	event.scale && event.scale !== 1 && event.preventDefault();
}, { passive: false, capture: true });

// Base Preact mounting:
let root;
let rootEl = document.querySelector('#root');
function renderApp() {
	let App = require('./components/app.jsx').default;
	root = render(<App />, rootEl, root);
}

// // register ServiceWorker via OfflinePlugin, for prod only:
// if (process.env.NODE_ENV === 'production') {
// 	// require('./pwa');
// }

// in development, set up HMR:
if (module.hot) {
	module.hot.accept('./components/app.jsx', renderApp);
}

renderApp();



// WEBPACK FOOTER //
// ./app/frontend/index.js